import { render, staticRenderFns } from "./HeaderLogo.vue?vue&type=template&id=0ddcbe65&scoped=true&"
import script from "./HeaderLogo.vue?vue&type=script&lang=ts&"
export * from "./HeaderLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddcbe65",
  null
  
)

export default component.exports